<template>
  <Wrapper
    bgColor="#FFF"
    contentWidth="lg"
    wrapperHeight="viewport"
  >
    <div class="py-12">

      <h2 class="playfair-display text-4xl text-center mb-6">
        Our Fee
      </h2>

      <p class="text-center mb-6">
        Most property managers hide lots of owner fees in the fine print — we don’t
      </p>

      <p class="text-center mb-8 text-lg">
        We charge a single fee: <b>10% of Rent</b>
      </p>

      <div class="bg-neutral-800 text-white p-6 rounded-xl mb-8 text-sm md:text-base">
        <div class="flex items-center text-lg font-bold text-center mb-2 rounded overflow-hidden">
          <div class="w-1/3 p-2 bg-neutral-700">Fee Type</div>
          <div class="w-1/3 p-2 bg-brand-primary-500">Urban City</div>
          <div class="w-1/3 p-2 bg-neutral-700">Other P.M.'s</div>
        </div>
        <template v-for="fee in fees">
          <div class="flex items-center my-1">
            <div class="w-1/3 p-2">{{ fee.type }}</div>
            <div class="w-1/3 p-2 font-bold text-center">
              <span :class="[fee.highlight ? 'underline-hand' : null]">{{ fee.urbanCity }}</span>
            </div>
            <div class="w-1/3 p-2 text-center">{{ fee.competitors }}</div>
          </div>
        </template>
      </div>

      <p class="text-center mb-6">
        Our single fee means no surprises, no markups, just straightforward management that protects your
        investment.
      </p>

    </div>

  </Wrapper>
</template>

<script>
import numeral from 'numeral';

import Button from './Button.vue';
import Wrapper from './Wrapper.vue';

export default {
  name: 'Fees',
  components: {
    Button,
    Wrapper,
  },
  computed: {},
  data() {
    return {
      fees: [
        {
          type: 'Monthly Management Fee',
          urbanCity: '10% of Rent',
          competitors: '6% - 12% of Rent',
          highlight: true,
        },
        {
          type: 'Leasing Fee',
          urbanCity: 'Included',
          competitors: `50-100% of One Month's Rent`
        },
        {
          type: 'Lease Renewal Fee',
          urbanCity: 'Included',
          competitors: `50-100% of One Month's rent `
        },
        {
          type: 'Tenant Placement Fee',
          urbanCity: 'Included',
          competitors: `50-100% of One Month's Rent`
        },
        {
          type: 'Inspection Fees',
          urbanCity: 'Included',
          competitors: '$75-$150 per Visit'
        },
        {
          type: 'Eviction Coordination',
          urbanCity: 'Included',
          competitors: '$500-$1,500 min. per Case'
        },
        {
          type: 'Maintenance Markups',
          urbanCity: 'None',
          competitors: '10-20% Extra'
        },
        {
          type: 'Hidden Fees', urbanCity: 'None', competitors: 'Surprise Charges'
        }
      ],
      proposal: window.app.proposal,
    };
  },
  methods: {
    numeral(value) {
      return numeral(value);
    }
  },
}
</script>

<style scoped lang="scss">

</style>
